document.addEventListener('turbo:load', function () {
  $('#keywords').on('input', function (q) {
    Spree.ajax({
      method: 'GET',
      data: { keywords: this.value },
      url: Spree.pathFor('products/search'),
    });
  });
});
